<script>
import AddReview from '@app/Review-v2/Add'

export default {
  name: 'ReviewModalTrigger',

  props: {
    info: {},
    inline: {},
    field_id: {},
    title: {},
    has_reviews: {},
  },

  methods: {
    openPopup() {
      this.$modal.show(
        AddReview,
        {
          info: this.info,
          inline: this.inline,
          field_id: this.field_id,
          title: this.title,
          has_reviews: this.has_reviews,
        }, {
          height: 'auto',
          classes: ['extralarge-modal'],
          adaptive: true,
          scrollable: true,
        }
      )
    },
  },

  render() {
    return this.$scopedSlots.default({
      open: () => {
        this.openPopup()
      },
    })
  },
}
</script>
